var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaq = function SvgFaq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0001,
    cy: 11,
    r: 9.28571,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.79583C8.02734 7.96185 8.31901 7.28737 8.875 6.77239C9.43555 6.25742 10.2103 5.99993 11.1992 5.99993C12.1289 5.99993 12.8809 6.24147 13.4551 6.72454C14.0339 7.20761 14.3232 7.82968 14.3232 8.59075C14.3232 9.57057 13.8402 10.3476 12.874 10.9218C12.4274 11.1861 12.1243 11.4277 11.9648 11.6464C11.8053 11.8606 11.7256 12.1363 11.7256 12.4736V12.8632H10.1396L10.1328 12.3984C10.1009 11.8925 10.1852 11.471 10.3857 11.1337C10.5908 10.7965 10.9326 10.4866 11.4111 10.204C11.8395 9.94427 12.1357 9.70501 12.2998 9.48626C12.4639 9.26295 12.5459 8.98496 12.5459 8.65228C12.5459 8.29225 12.4137 7.9983 12.1494 7.77044C11.8851 7.54257 11.5387 7.42864 11.1104 7.42864C10.6729 7.42864 10.3197 7.55169 10.0508 7.79778C9.7819 8.04388 9.63379 8.37656 9.60645 8.79583H8ZM11.0078 16.124C10.666 16.124 10.3903 16.026 10.1807 15.83C9.97559 15.6295 9.87305 15.3652 9.87305 15.037C9.87305 14.7044 9.97559 14.44 10.1807 14.2441C10.3903 14.0436 10.666 13.9433 11.0078 13.9433C11.3542 13.9433 11.6299 14.0436 11.835 14.2441C12.04 14.44 12.1426 14.7044 12.1426 15.037C12.1426 15.3652 12.04 15.6295 11.835 15.83C11.6299 16.026 11.3542 16.124 11.0078 16.124Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faq.684e940c.svg";
export { ForwardRef as ReactComponent };